import {TransitionProps} from "@mui/material/transitions";
import React, {FC} from "react";
import {alpha, Breakpoint, Dialog, DialogActions, DialogContent, Skeleton, Slide, Theme} from "@mui/material";
import {getRandomNumber} from "../../../util/utils";
import CustomDialogTitle from "./custom-dialog-title/CustomDialogTitle";
import {useTheme} from "@mui/material/styles";
import {SxProps} from "@mui/system";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
    open: boolean
    handleDialogClose: () => void
    title?: string
    content: React.ReactElement
    actions?: React.ReactElement
    loading?: boolean
    error?: boolean
    maxWidth?: Breakpoint
    sx?: SxProps<Theme>
    contentSx?: SxProps<Theme>
    dialogId?: string
}

const CustomDialog: FC<Props> = ({
                                     loading = false,
                                     error = false,
                                     actions = <></>,
                                     maxWidth = 'sm',
                                     ...props
                                 }) => {
    const theme = useTheme()
    const hasActions = React.isValidElement(actions) && actions.type === React.Fragment
        ? React.Children.count((actions.props as any)?.children) > 0
        : React.Children.count(actions) > 0

    return (
        <Dialog TransitionComponent={Transition}
                open={props.open}
                fullWidth
                maxWidth={maxWidth}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: alpha(theme.palette.secondary.main, .6),
                            backdropFilter: 'blur(2px)'
                        },
                    },
                }}
                PaperProps={{
                    'data-genie-dialog-id': props.dialogId ?? 'dialog',
                    sx: {
                        m: {xs: 1, sm: 4},
                        width: {xs: 'calc(100% - 16px)', sm: undefined},
                        maxHeight: {xs: 'calc(100% - 16px)', sm: 'calc(100% - 64px)'},
                        ...props.sx,
                    }
                }}
                onClose={props.handleDialogClose}>
            {props.title ? <CustomDialogTitle onClose={props.handleDialogClose}>
                {loading ? <Skeleton width={`${getRandomNumber(20, 60)}%`} animation='wave'/> : props.title}
            </CustomDialogTitle> : null}
            <DialogContent sx={{
                px: {xs: 2, sm: 3},
                py: {xs: 1.5, sm: 2.5},
                ...props.contentSx,
            }}>
                {props.content}
            </DialogContent>
            {hasActions ? (
                <DialogActions sx={{px: {xs: 2, sm: 3}, py: {xs: 1.25, sm: 1.5}}}>
                    {actions}
                </DialogActions>
            ) : null}
        </Dialog>
    )
}

export default CustomDialog
